import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import "./tokenomics.css";
import Landing from "./pages/Landing";
import BlockchainGaming from "./pages/BlockchainGaming";
import Tokenomics from "./pages/Tokenomics";
import Ico from "./pages/Ico";
import GamingComingSoon from "./pages/GamingComingSoon";
import Whitepaper from "./pages/Whitepaper";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/blockchain" element={<BlockchainGaming />} />
          <Route path="/gaming" element={<GamingComingSoon />} />
          <Route path="/tokenomics" element={<Tokenomics />} />
          <Route path="/ico" element={<Ico />} />
          <Route path="/whitepaper" element={<Whitepaper />} />
          <Route path="/whitepaper/:sectionId" element={<Whitepaper />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
